<template>
  <div class="row" style="margin-bottom: 0.5em">
    <div class="col-sm-4">
      <CardInfoWidget
        title="Ativas"
        :value="ativas"
        icon="bullhorn"
        color="success"
      />
    </div>
    <div class="col-sm-4">
      <CardInfoWidget
        title="Agendadas"
        :value="agendadas"
        icon="clock"
        color="warning"
      />
    </div>
    <div class="col-sm-4">
      <CardInfoWidget
        title="Encerrando em 7 dias"
        :value="encerrando"
        icon="exclamation-triangle"
        color="danger"
      />
    </div>
  </div>
</template>

<script>
import CardInfoWidget from "@/components/charts/CardInfoWidget";

export default {
  name: "CampanhaStatsRow",
  components: {
    CardInfoWidget,
  },
  props: {
    ativas: {
      type: Number,
      default: 0,
    },
    agendadas: {
      type: Number,
      default: 0,
    },
    encerrando: {
      type: Number,
      default: 0,
    },
  },
};
</script>
